import React, { useState, Fragment } from 'react';
import { Button, ButtonGroup, Dialog } from '@tencent/spaui';
import copy from 'copy-to-clipboard';

import { RPCFactory } from '../../../utils/RequestUtil';
import useDialog from '../../../leads_component/shared-components/hooks/useDialog';

const MyDialog = (props) => {
  const errorDialogHooks = useDialog({ showDialog: false });

  const [platform, setPlatform] = useState(1);
  const [text, setText] = useState('');

  const handleCopy = () => {
    const content = errorDialogHooks.contentProps.data;

    if (copy(content)) {
      props.feedbackHooks.showSuccessTip('复制成功');
    } else {
      props.feedbackHooks.showErrorTip('您的浏览器不支持复制，请手动复制');
    }
  };
  const onSubmit = () => {
    RPCFactory.multiaccount
      .bindSubAccount({
        platform,
        subAccountIds: platform == 1 ? text.split(',') : [],
        subWeChatAppIds: platform == 2 ? text.split(',') : [],
      })
      .done((resp) => {
        props.onSubmit();
      })
      .fail((code, msg) => {
        errorDialogHooks.showAsEditModel(msg);
      });
  };
  return (
    <Fragment>
      <div className="configs">
        <ul className="config-list">
          <li className="config-li">
            <div className="form-in">
              <ButtonGroup>
                <Button
                  bsStyle={platform == 1 ? 'primary' : 'default'}
                  onClick={() => {
                    setPlatform(1);
                  }}
                >
                  腾讯广告平台
                </Button>
                <Button
                  bsStyle={platform == 2 ? 'primary' : 'default'}
                  onClick={() => {
                    setPlatform(2);
                  }}
                >
                  微信广告平台
                </Button>
              </ButtonGroup>
            </div>
          </li>
          <li className="config-li">
            <p className="name">广告账号ID</p>
            <div className="form-in">
              <textarea
                className="spaui-input"
                placeholder={
                  platform == 1
                    ? '请输入广告主账号ID，支持添加多个，英文逗号分隔'
                    : '请输入APPID，支持添加多个，英文逗号分隔'
                }
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
              ></textarea>
            </div>
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button onClick={props.onCancel}>取消</Button>
        <Button bsStyle="primary" onClick={onSubmit}>
          提交
        </Button>
      </div>
      {errorDialogHooks.showDialog ? (
        <Dialog
          {...errorDialogHooks}
          backdrop
          type="normal"
          className="spaui-dialog-confirm-normal modal-bind-fail"
          title="部分账号绑定失败"
          iconType="warning"
          style={{ width: '580px' }}
          submitLabel="我知道了"
          cancelButton={false}
        >
          <div className="idlist">
            <p className="bd">
              {errorDialogHooks.contentProps.data}
              <a href="javascript:void(0)" onClick={handleCopy}>
                复制
              </a>
            </p>
          </div>
        </Dialog>
      ) : null}
    </Fragment>
  );
};

export default MyDialog;
